import { render, staticRenderFns } from "./createFolder.vue?vue&type=template&id=69e32122"
import script from "./createFolder.vue?vue&type=script&lang=js"
export * from "./createFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports